<dw-ui-dialog-box
  [title]="title"
  [saveLabel]="'Doc::CustomerSalesPurchase:ToCustomerInvoice' | abpLocalization"
  (saveFn)="generateDepositInvoice()"
>
  @if (!isLoading) {
    <form [formGroup]="form">
      <div class="row my-2">
        <div>
          <label for="description" class="form-label text-primary" dwInputRequired>
            {{ '::Description' | abpLocalization }}
          </label>
          <input id="description" type="text" class="form-control" formControlName="description" />
        </div>
      </div>
      <div class="row my-2">
        <div>
          <label for="amount" class="form-label text-primary" dwInputRequired>
            {{ 'Doc::Amount' | abpLocalization }}
          </label>
          <input
            id="amount"
            class="form-control"
            formControlName="amount"
            [autoMask]="'currency'"
          />
        </div>
      </div>
      <div class="row my-2">
        <div>
          <label for="paymentTermId" class="form-label text-primary">
            {{ 'GoliathCore::PaymentTerm' | abpLocalization }}
          </label>

          <ng-select
            class="form-control"
            id="paymentTermId"
            formControlName="paymentTermId"
            bindLabel="code"
            bindValue="id"
            [items]="paymentTerms"
          >
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <span [title]="item?.name?.current">
                {{ item?.name?.current }} - {{ item.code }}
              </span>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </form>
  }
</dw-ui-dialog-box>
